module.exports = __webpack_public_path__ + "static/media/temp_19.dd82d2ca.jpg";